import { Button, Spinner } from 'avo-ui'
import { SUBMIT_TYPE } from 'constants/constant'
import { GeneralDataContainer } from '../../../containers/flash-sale/flash-sale-create/general-data/GeneralDataContainer'
import { ProductItemContainer } from '../../../containers/flash-sale/flash-sale-create/product-item/ProductItemContainer'

export const FlashSaleCreate = ({
    sectionProps,
    isLoadingUpload,
    isLoading,
    isCreating,
    isUpdating,
    isDrafting,
    onSubmit,
}) => {
    return (
        <div className={'flex flex-col space-y-3 px-9 py-4'}>
            {isLoading ? (
                <Spinner className={'w-8 h-8 my-10 mx-auto !border-blue-50'} />
            ) : (
                <>
                    <div className={'flex flex-col space-y-6'}>
                        <GeneralDataContainer {...sectionProps} />
                        <ProductItemContainer {...sectionProps} />
                    </div>
                    <div className={'flex py-3 space-x-3 justify-center'}>
                        <Button
                            className={'w-[200px]'}
                            type={'outline'}
                            title={'Draft'}
                            loading={(isLoadingUpload || isCreating || isUpdating) && isDrafting}
                            onClick={() => onSubmit(SUBMIT_TYPE?.DRAFT)}
                        />
                        <Button
                            className={'w-[200px]'}
                            title={'Publish'}
                            loading={(isLoadingUpload || isCreating || isUpdating) && !isDrafting}
                            onClick={() => onSubmit(SUBMIT_TYPE?.PUBLISH)}
                        />
                    </div>
                </>
            )}
        </div>
    )
}
